/* Start Bootstrap - SB Admin */
(function($) {
    "use strict";

    // Add active state to sidbar nav links
    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $("#layoutSidenav_nav .sb-sidenav a.nav-link").each(function() {
        if (this.href === path) {
            $(this).addClass("active");
        }
    });

    // Toggle the side navigation
    $("#sidebarToggle").on("click", function(e) {
        e.preventDefault();
        $("body").toggleClass("sb-sidenav-toggled");
    });
})(jQuery);


$( document ).ready(function() {

    $('.selectpicker').selectpicker();

    $('input').attr('autocomplete','off');

    $ ( '.upper' ).keyup ( function () {
        this.value = this.value.toUpperCase ();
    } );

    inputTypeCall();

    datepicker();

    $('[data-toggle="popover"]').popover();
    $('.popover').popover();

    $('[data-toggle="tooltip"]').tooltip();
    $('.tooltip').tooltip();
});